import {
  SlPopup
} from "./chunk.5J7BMMD5.js";

// src/components/popup/popup.ts
var popup_default = SlPopup;
SlPopup.define("sl-popup");

export {
  popup_default
};
